<template>
  <div>
    <!-- <iframe v-if="imgUrl.indexOf('.pdf')>-1" :src="imgUrl" class="iframe_" frameborder="0"></iframe> -->
    <pdf
      :page="currentPage"
      @num-pages="pageCount = $event"
      @page-loaded="currentPage = $event"
      @loaded="loadPdfHandler"
      v-if="imgUrl.indexOf('.pdf') > -1"
      :src="imgUrl"
    />
    <img v-else class="img_" :src="imgUrl" alt="img" />

    <p class="arrow2" v-if="imgUrl.indexOf('.pdf') > -1">
      <span
        class="btn_"
        @click="changePdfPage(0)"
        :class="{ grey: currentPage == 1 }"
        >上一页</span
      >
      {{ currentPage }} / {{ pageCount }}
      <span
        class="btn_"
        @click="changePdfPage(1)"
        :class="{ grey: currentPage == pageCount }"
        >下一页</span
      >
    </p>
  </div>
</template>

<script>
import api from "@/utils/api";
import pdf from "vue-pdf";
export default {
  components: { pdf },
  data() {
    return {
      currentPage: 0, // pdf文件页码
      pageCount: 10, // pdf文件总页数
      fileType: "pdf", // 文件类型
      imgUrl: ""
    };
  },
  mounted() {
    this.getNotification();
  },
  methods: {
    getNotification() {
      let data = {
        userId: this.$route.query.userid,
        productCode: this.$route.query.productCode
      };
      console.log(data);
      api.customerNotification(data).then(res => {
        this.imgUrl = res.data.content;
      });
    },
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage(val) {
      // console.log(val)
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
        // console.log(this.currentPage)
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
        // console.log(this.currentPage)
      }
    },
    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1; // 加载的时候先加载第一页
    }
  }
};
</script>

<style lang="scss" scoped>
.iframe_ {
  min-height: 100vh;
  width: 100vw;
}
.img_ {
  height: auto;
  width: 100vw;
}
.arrow2{
    width: 100%;
    position: fixed;
    bottom: 20px;
    left:0;
    font-size: 15px;
    .btn_{
        font-size: 13px;
    }
}
</style>
